import React from "react";
import "./quicklinkspage.css";

export default function Quicklinkspage() {
  return (
    <div className="links">
      <div className="linkswrapper2">
        <div className="linksheading">QUICK LINKS</div>
        <div className="linkssubheadings">
          <div className="leftlink">
            <a href="/home">Home</a>
            <a href="/products">Products</a>
            <a href="/portal">Portal</a>
            <a href="/account">Account</a>
          </div>
          <div className="center">
            <a href="/whyus">Why us</a>
            <a href="/services">Services</a>
            <a href="/contactus">Contactus</a>
            <a href="/socialmedia">Social media</a>
          </div>
          <div className="rightlink">
            <a href="/innovations">Innovations</a>
            <a href="/careers">Careers</a>
            <a href="/terms">Terms</a>
            <a href="/more">More</a>
          </div>
        </div>
      </div>
    </div>
  );
}
